(ns hai.contacts.eql
  "The EQL shape contacts travel in, shared by every contact-editing surface.
   Mirrors [[hai.notes.eql]].")

(def contact-eql
  "The contact shape the editor works with — the shape any host should resolve
   for the contact it hands to the editor body."
  [:contact/uuid
   :contact/full-name
   :contact/email
   :contact/github-login
   :contact/linkedin-url
   :contact/organisation?
   :contact/org-mailing-namespace
   :contact/auto-filled-from-connection-email
   :contact/updated-at
   {:contact/members [:contact/uuid :contact/full-name]}
   ;; Needed by `sharing/owner?`, which alone unlocks Delete.
   :user.entity/permissions
   :user.entity/owner?])
